export const t = {
  // Header
  home: { pt: 'Início', en: 'Home' },
  products: { pt: 'Produtos', en: 'Products' },
  feedbacks: { pt: 'Feedbacks', en: 'Feedbacks' },
  login: { pt: 'Login', en: 'Login' },
  logout: { pt: 'Sair', en: 'Logout' },
  orders: { pt: 'Pedidos', en: 'Orders' },
  support: { pt: 'Suporte', en: 'Support' },

  // Home Hero
  dominate: { pt: 'DOMINE O', en: 'DOMINATE' },
  freeFire: { pt: 'FREE FIRE', en: 'FREE FIRE' },
  heroSubtitle: { pt: 'Os únicos painéis que você consegue usar na principal, sem dor de cabeça ou riscos', en: 'The only panels you can use on your main account, hassle-free and risk-free' },
  viewProducts: { pt: 'VER PRODUTOS', en: 'VIEW PRODUCTS' },
  buyNow: { pt: 'COMPRAR AGORA', en: 'BUY NOW' },
  activeClients: { pt: 'Clientes Ativos', en: 'Active Clients' },
  onlineSupport: { pt: 'Suporte Online', en: 'Online Support' },
  rating: { pt: 'Avaliação', en: 'Rating' },

  // Video Section
  seeInAction: { pt: 'VEJA EM', en: 'SEE IT IN' },
  action: { pt: 'AÇÃO', en: 'ACTION' },
  watchGameplay: { pt: 'Assista nosso painel dominando em gameplay real', en: 'Watch our panel dominating in real gameplay' },
  clickToListen: { pt: 'Clique para ouvir', en: 'Click to listen' },

  // Why Choose
  whyChoose: { pt: 'POR QUE ESCOLHER A', en: 'WHY CHOOSE' },
  bestFeatures: { pt: 'Os melhores recursos para dominar suas partidas', en: 'The best features to dominate your matches' },
  safe: { pt: '100% Seguro', en: '100% Safe' },
  safeDesc: { pt: 'Sistema anti-ban avançado para proteger sua conta durante todo o uso', en: 'Advanced anti-ban system to protect your account during all use' },
  instantUpdates: { pt: 'Atualizações Instantâneas', en: 'Instant Updates' },
  instantUpdatesDesc: { pt: 'Sempre atualizado com as últimas versões e patches do Free Fire', en: 'Always updated with the latest Free Fire versions and patches' },
  premiumSupport: { pt: 'Suporte Premium 24/7', en: 'Premium 24/7 Support' },
  premiumSupportDesc: { pt: 'Equipe especializada pronta para ajudar você a qualquer momento', en: 'Specialized team ready to help you at any time' },
  activeCommunity: { pt: 'Comunidade Ativa', en: 'Active Community' },
  activeCommunityDesc: { pt: 'Faça parte de uma comunidade de jogadores de elite', en: 'Join a community of elite players' },
  instantDelivery: { pt: 'Entrega Instantânea', en: 'Instant Delivery' },
  instantDeliveryDesc: { pt: 'Receba seu acesso imediatamente após a confirmação do pagamento', en: 'Receive your access immediately after payment confirmation' },
  qualityGuarantee: { pt: 'Garantia de Qualidade', en: 'Quality Guarantee' },
  qualityGuaranteeDesc: { pt: 'Painéis testados e aprovados por milhares de jogadores', en: 'Panels tested and approved by thousands of players' },

  // CTA
  readyToDominate: { pt: 'PRONTO PARA DOMINAR?', en: 'READY TO DOMINATE?' },
  joinThousands: { pt: 'Junte-se a milhares de jogadores que já estão no topo do ranking', en: 'Join thousands of players already at the top of the rankings' },

  // Products
  ourProducts: { pt: 'NOSSOS PRODUTOS', en: 'OUR PRODUCTS' },
  choosePanel: { pt: 'Escolha o painel perfeito para dominar Free Fire', en: 'Choose the perfect panel to dominate Free Fire' },
  bestSeller: { pt: 'MAIS VENDIDO', en: 'BEST SELLER' },
  panelHighlights: { pt: 'Destaques do Painel', en: 'Panel Highlights' },
  instantDeliveryShort: { pt: 'Envio imediato', en: 'Instant delivery' },
  legitAimbot: { pt: 'Aimbot Legit com regulagem', en: 'Legit Aimbot with adjustments' },
  ultraAimbot: { pt: 'Aimbot Ultra agressivo', en: 'Ultra aggressive Aimbot' },
  freezeAimbot: { pt: 'Aimbot Freeze para matar atrás do cover', en: 'Freeze Aimbot to kill behind cover' },
  allEsp: { pt: 'Todas as ESP possíveis', en: 'All possible ESP features' },
  easyInstall: { pt: 'Instalação fácil com suporte no Discord e WhatsApp', en: 'Easy install with Discord & WhatsApp support' },
  save: { pt: 'Economize', en: 'Save' },
  buy: { pt: 'Comprar', en: 'Buy' },
  gotQuestions: { pt: 'TEM DÚVIDAS?', en: 'GOT QUESTIONS?' },
  teamAvailable: { pt: 'Nossa equipe está disponível 24/7 para ajudar você', en: 'Our team is available 24/7 to help you' },
  contactSupport: { pt: 'FALAR COM SUPORTE', en: 'CONTACT SUPPORT' },
  loading: { pt: 'CARREGANDO...', en: 'LOADING...' },
  fetchingProducts: { pt: 'Buscando produtos disponíveis', en: 'Fetching available products' },
  errorLoadingProducts: { pt: 'Erro ao carregar produtos', en: 'Error loading products' },
  tryAgainLater: { pt: 'Tente novamente mais tarde', en: 'Please try again later' },
  addedToCart: { pt: 'Adicionado ao carrinho!', en: 'Added to cart!' },
  errorAddToCart: { pt: 'Não foi possível adicionar ao carrinho', en: 'Could not add to cart' },
  error: { pt: 'Erro', en: 'Error' },

  // Cart
  shoppingCart: { pt: 'CARRINHO DE COMPRAS', en: 'SHOPPING CART' },
  emptyCart: { pt: 'SEU CARRINHO ESTÁ VAZIO', en: 'YOUR CART IS EMPTY' },
  emptyCartDesc: { pt: 'Adicione produtos incríveis ao carrinho para começar a dominar', en: 'Add awesome products to your cart to start dominating' },
  plan: { pt: 'Plano', en: 'Plan' },
  validity: { pt: 'Validade', en: 'Validity' },
  orderSummary: { pt: 'RESUMO DO PEDIDO', en: 'ORDER SUMMARY' },
  subtotal: { pt: 'Subtotal', en: 'Subtotal' },
  discount: { pt: 'Desconto', en: 'Discount' },
  total: { pt: 'TOTAL', en: 'TOTAL' },
  youreSaving: { pt: 'Você está economizando', en: "You're saving" },
  itemRemoved: { pt: 'Item removido', en: 'Item removed' },
  itemRemovedDesc: { pt: 'O item foi removido do carrinho', en: 'The item has been removed from your cart' },
  checkoutBrazil: { pt: 'FINALIZAR COMPRA', en: 'CHECKOUT' },
  brazilPayment: { pt: 'Pagamento via PicPay', en: 'Payment via PicPay' },
  pixBoleto: { pt: 'PicPay - Pagamento direto pelo banco', en: 'PicPay - Direct bank payment' },
  intlCheckout: { pt: 'PAGAMENTO INTERNACIONAL ($)', en: 'INTERNATIONAL CHECKOUT ($)' },
  intlPayment: { pt: 'Pagamento Internacional', en: 'International Payment' },
  creditPaypal: { pt: 'Cartão / PayPal - Moeda USD', en: 'Credit Card / PayPal - USD currency' },
  securePayment: { pt: 'Pagamento 100% seguro', en: '100% secure payment' },
  instantDeliveryAfter: { pt: 'Entrega instantânea após confirmação', en: 'Instant delivery after confirmation' },
  sendReceipt: { pt: 'ENVIAR COMPROVANTE', en: 'SEND RECEIPT' },
  sendReceiptDesc: { pt: 'Já pagou? Envie seu comprovante para liberação', en: 'Already paid? Send your receipt for verification' },
  fullName: { pt: 'Nome Completo', en: 'Full Name' },
  whatsapp: { pt: 'WhatsApp', en: 'WhatsApp' },
  email: { pt: 'Email', en: 'Email' },
  receiptPhoto: { pt: 'Foto do Comprovante', en: 'Receipt Photo' },
  sending: { pt: 'ENVIANDO...', en: 'SENDING...' },
  receiptSent: { pt: 'Comprovante enviado com sucesso!', en: 'Receipt sent successfully!' },
  receiptSentDesc: { pt: 'Vamos verificar e liberar seu acesso em breve', en: 'We will verify and release your access soon' },
  receiptError: { pt: 'Erro ao enviar comprovante', en: 'Error sending receipt' },
  fillAllFields: { pt: 'Preencha todos os campos e anexe o comprovante', en: 'Fill all fields and attach the receipt' },
  selectFile: { pt: 'Selecionar arquivo', en: 'Select file' },
  fileSelected: { pt: 'Arquivo selecionado', en: 'File selected' },

  // Feedbacks
  customerFeedbacks: { pt: 'FEEDBACKS DOS CLIENTES', en: 'CUSTOMER FEEDBACKS' },
  seeWhatCustomers: { pt: 'Veja o que nossos clientes estão dizendo sobre nossos produtos', en: 'See what our customers are saying about our products' },
  satisfiedCustomers: { pt: 'Clientes Satisfeitos', en: 'Satisfied Customers' },
  averageRating: { pt: 'Avaliação Média', en: 'Average Rating' },
  recommendations: { pt: 'Recomendações', en: 'Recommendations' },
  support247: { pt: 'Suporte 24/7', en: '24/7 Support' },
  realProof: { pt: 'PROVAS REAIS', en: 'REAL PROOF' },
  testimonials: { pt: 'DEPOIMENTOS', en: 'TESTIMONIALS' },
  beTheNext: { pt: 'SEJA O PRÓXIMO A DOMINAR!', en: 'BE THE NEXT TO DOMINATE!' },
  joinSatisfied: { pt: 'Junte-se aos nossos clientes satisfeitos e comece a vencer agora', en: 'Join our satisfied customers and start winning now' },

  // Footer
  quickLinks: { pt: 'Links Rápidos', en: 'Quick Links' },
  cart: { pt: 'Carrinho', en: 'Cart' },
  footerDesc: { pt: 'Os melhores painéis e cheats para Free Fire. Domine o jogo com segurança e suporte dedicado 24/7.', en: 'The best panels and cheats for Free Fire. Dominate the game with safety and 24/7 dedicated support.' },
  support24via: { pt: 'Suporte 24/7 via WhatsApp', en: '24/7 Support via WhatsApp' },
  securePaymentFooter: { pt: 'Pagamento Seguro', en: 'Secure Payment' },
  allRights: { pt: 'Todos os direitos reservados.', en: 'All rights reserved.' },
  builtTo: { pt: 'Feito para dominar Free Fire', en: 'Built to dominate Free Fire' },

  // Popup
  welcome: { pt: 'BEM-VINDO!', en: 'WELCOME!' },
  exclusiveDeals: { pt: 'Promoções Exclusivas!', en: 'Exclusive Deals!' },
  popupDesc1: { pt: 'Aproveite nossas', en: 'Check out our' },
  popupDesc2: { pt: 'promoções especiais', en: 'special promotions' },
  popupDesc3: { pt: 'melhore sua mira', en: 'improve your aim' },
  popupDesc4: { pt: 'no Free Fire!', en: 'in Free Fire!' },
  emulator: { pt: 'Emulador', en: 'Emulator' },
  supportShort: { pt: 'Suporte', en: 'Support' },

  // Login
  welcomeTo: { pt: 'BEM-VINDO À', en: 'WELCOME TO' },
  loginSubtitle: { pt: 'Faça login para completar sua compra e dominar Free Fire', en: 'Log in to complete your purchase and dominate Free Fire' },
  securePaymentLogin: { pt: 'Pagamento 100% Seguro', en: '100% Secure Payment' },
  instantAfterPayment: { pt: 'Entrega Instantânea após Pagamento', en: 'Instant Delivery After Payment' },
  premiumSupport247: { pt: 'Suporte Premium 24/7', en: 'Premium 24/7 Support' },
  signInCreate: { pt: 'ENTRAR OU CRIAR CONTA', en: 'SIGN IN OR CREATE ACCOUNT' },
  useGoogle: { pt: 'Use sua conta Google para entrar ou criar uma nova conta', en: 'Use your Google account to sign in or create a new account' },
  signInBtn: { pt: 'Entrar / Criar Conta', en: 'Sign In / Create Account' },
  dataProtected: { pt: 'Seus dados estão protegidos. Usamos autenticação segura do Google.', en: 'Your data is protected. We use Google\'s secure authentication.' },
  termsAgree: { pt: 'Ao fazer login, você concorda com nossos Termos de Serviço e Política de Privacidade', en: 'By logging in, you agree to our Terms of Service and Privacy Policy' },
};

export const useTranslation = (isBrazil) => {
  const lang = isBrazil ? 'pt' : 'en';
  return (key) => t[key]?.[lang] || t[key]?.en || key;
};

// English translations for DB-driven product content (keyed by product id)
export const productTranslations = {
  '2': { name: 'ANDROID INTERNAL PANEL', description: 'Cheat optimized for Android devices. Intuitive interface and powerful features to dominate the game.' },
  '3': { name: 'iOS INTERNAL PANEL', description: 'Exclusive solution for iOS. Compatible with the latest operating system versions.' },
  '1': { name: 'EMULATOR INTERNAL CORE', description: 'Complete panel with the best features for Free Fire on emulator. Includes aimbot, ESP, wallhack and much more.' },
  '5': { name: 'BYPASS 50 PLAYERS', description: 'Play against mobile players directly from your emulator, unlocking 50 players on the map instead of 30. Compatible with mobile ranked queues and Camp mode.' },
  '6': { name: 'AIMLESS MENU', description: 'Premium external menu controlled directly from your phone while playing on emulator. Maximum safety and precision.' },
};

export const planTypeTranslations = {
  '15 Dias': '15 Days',
  '10 dias': '10 Days',
  '1 Mes': '1 Month',
  '3 Meses': '3 Months',
  'Permanente': 'Lifetime',
};

export const trProductName = (isBrazil, id, ptName) => (isBrazil ? ptName : (productTranslations[id]?.name || ptName));
export const trProductDesc = (isBrazil, id, ptDesc) => (isBrazil ? ptDesc : (productTranslations[id]?.description || ptDesc));
export const trPlanType = (isBrazil, ptType) => (isBrazil ? ptType : (planTypeTranslations[ptType] || ptType));
